import { bindEvents, offset } from '../../assets/js/helpers';

import OverlayController from '../../assets/js/controller/overlay';
import SectionController from '../../assets/js/controller/section';


const selector = 'video-trigger';

export default class VideoTrigger {

	constructor(button) {
		this.el = {
			button,
			wrapper: button.querySelector(`.${selector}__wrapper`)
		};

		this.timeout = null;

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	static get selector() {
		return selector;
	}

	_onButtonClick(e) {
		e.preventDefault();
		const left = offset.left(this.el.wrapper);
		const top = offset.top(this.el.wrapper);
		const width = this.el.wrapper.offsetWidth;
		const height = this.el.wrapper.offsetHeight;
		let scale = window.innerWidth / width;
		if (scale * height < window.innerHeight) scale = window.innerHeight / height;
		this.el.button.classList.add('zoom-in');
		this.el.wrapper.style.transform = `translate3d(${(-left) - (scale * width - window.innerWidth) / 2}px,-${top - window.scrollY + (parseInt(this.el.button.dataset.cursorOffset, 10) || 0)}px,0) scale3d(${scale},${scale},1)`;
		SectionController.globals['fixed-header'].hide();
		this.timeout = setTimeout(() => {
			OverlayController.open('videoPlayer');
			this.timeout = setTimeout(() => {
				this.el.button.classList.remove('zoom-in');
				this.el.wrapper.style.transformOrigin = '';
				this.el.wrapper.style.transform = '';
				SectionController.globals['fixed-header'].show();
			}, 1000);
		}, 500);
	}

	addEventListeners() {
		this.el.button.addEventListener('click', this.events._onButtonClick);
	}

	removeEventListeners() {
		this.el.button.removeEventListener('click', this.events._onButtonClick);
	}

	destroy() {
		if (this.timeout) clearTimeout(this.timeout);
		this.removeEventListeners();
	}

}
